module.exports = __webpack_public_path__ + "img/Iraq.2c9aa4f6.gif";